import { OS } from '@/lib/constants/assets'

export const TEXT_FIELD_VARIANTS = {
  STANDARD: 'standard',
  FILLED: 'filled',
  OUTLINED: 'outlined',
} as const
export const BUTTON_VARIANTS = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined',
  TEXT: 'text',
} as const

export const Z_INDEX = {
  PRIMARY_DRAWER: 'z-[1300]',
  SECONDARY_DRAWER: 'z-[1400]',
  DIALOG: 'z-[1500]',
  POPOVER: 'z-[1600]',
  TOOLTIP: 'z-[1700]',
} as const

export const DRAWER_WIDTH = {
  SECONDARY_DRAWER: 'w-[27vw] min-w-[500px]',
  PRIMARY_DRAWER: 'w-[28vw] min-w-[600px]',
} as const

export const DRAWER_STACKING = {
  PRIMARY_Z_INDEX: 1300,
  SECONDARY_Z_INDEX: 1400,
  Z_INDEX_INCREMENT: 10,
  WIDTH_STEP_PX: 40,
  PRIMARY_WIDTH_VW: 28,
  PRIMARY_MIN_WIDTH_PX: 600,
} as const

// @TODO: Replace this on all charts/widgeets
export const CHARTS_LOCALE = 'en-US'

export const PLATFORM_ICONS: Record<string, string> = {
  macos: '/os-logos/macos.svg',
  windows: '/os-logos/windows.svg',
  linux: '/os-logos/linux.svg',
  ios: '/os-logos/ios.svg',
  android: '/os-logos/android.svg',
}

export const PLATFORMS = OS
